module.exports = __webpack_public_path__ + "static/media/20ECE9.1498e7b6.jpg";